var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useContext } from 'react';
import { IconButton } from '@michelin/acid-components';
import { Icon } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import GlobalSearchDialog from './GlobalSearchDialog';
import { useGetSelectedLocationAccountNumber } from '../../hooks/useGetSelectedLocationAccountNumber';
import { useSearchGlobal } from '../../request/useSearchGlobal';
var useStyles = makeStyles(function (theme) { return ({
    avatar: {
        background: 'none',
        '&:hover': {
            background: 'none',
            color: theme.palette.primary.dark,
            cursor: 'pointer',
        },
    },
}); });
export function GlobalSearch() {
    var _this = this;
    var classes = useStyles();
    var _a = __read(useState(false), 2), showDialog = _a[0], setShowDialog = _a[1];
    var _b = __read(useState(null), 2), results = _b[0], setResults = _b[1];
    var _c = __read(useState(''), 2), searchTerm = _c[0], setSearchTerm = _c[1];
    var _d = __read(useState({}), 2), resultsCache = _d[0], setResultCache = _d[1];
    var showGlobalSearch = useContext(CentralProviderContext).showGlobalSearch;
    var _e = useSearchGlobal(), searchGlobal = _e.searchGlobal, loading = _e.loading;
    var accountNumber = useGetSelectedLocationAccountNumber();
    var handleModal = function () { return setShowDialog(true); };
    var onSearchTerm = function (term, selectedItems) { return __awaiter(_this, void 0, void 0, function () {
        var itemsToSearch, savedItems_1, searchResults, mergedResults, newResultsCache_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setResults(null);
                    if (!term || term.length < 3 || selectedItems.length === 0) {
                        setResultCache({});
                        return [2 /*return*/];
                    }
                    itemsToSearch = __spreadArray([], __read(selectedItems), false);
                    if (term !== searchTerm) {
                        setSearchTerm(term);
                        setResultCache({});
                    }
                    else {
                        savedItems_1 = Object.keys(resultsCache);
                        itemsToSearch = selectedItems.filter(function (x) { return !savedItems_1.includes(x); });
                    }
                    if (!itemsToSearch.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, searchGlobal({
                            searchTerm: term,
                            itemsToSearch: itemsToSearch,
                            accountNumber: accountNumber,
                        })];
                case 1:
                    searchResults = _a.sent();
                    mergedResults = __assign(__assign({}, resultsCache), searchResults);
                    setResults(mergedResults);
                    setResultCache(mergedResults);
                    return [3 /*break*/, 3];
                case 2:
                    newResultsCache_1 = __assign({}, resultsCache);
                    Object.keys(resultsCache).forEach(function (key) {
                        if (!selectedItems.includes(key)) {
                            delete newResultsCache_1[key];
                        }
                    });
                    setResults(newResultsCache_1);
                    setResultCache(newResultsCache_1);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onClose = function () {
        setShowDialog(false);
        setResults(null);
        setSearchTerm('');
        setResultCache({});
    };
    if (!showGlobalSearch)
        return null;
    return (React.createElement("div", { style: {
            flexDirection: 'row',
            display: 'flex',
        } },
        React.createElement(IconButton, { variant: "default", color: "primary", disableFocusRipple: true, disableRipple: true, "data-testid": "global-search-button", className: classes.avatar, style: {
                height: '40px',
                width: '40px',
            }, onClick: handleModal },
            React.createElement(Icon, { style: { marginTop: '-3px' } },
                React.createElement(SearchIcon, null))),
        showDialog && React.createElement(GlobalSearchDialog, { onClose: onClose, results: results, onSearchTerm: onSearchTerm, searchLoading: loading })));
}
//# sourceMappingURL=GlobalSearch.js.map